import { GetStaticProps } from 'next'
import { currentCampaign } from '../content/campaigns'
import { HomePage, Props } from '../components/pages/HomePage'

export const getStaticProps: GetStaticProps<Props> = (context) => ({
  props: { campaign: currentCampaign() },
})

export default HomePage
